import { memo, useCallback, useEffect } from "react";
import { RefreshIcon,PlusCircleIcon } from "@heroicons/react/outline";
import { Refresh } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../constants";
import { useApi } from "../../../contexts/ApiContext";
import { useAuth } from "../../../contexts/AuthContext";
import { CollectionStage, UserMetadata } from "../../../types";
import Button from "../../../components/Button";
import NotificationList from "../../../components/NotificationList";
import DraftList from "../../../components/DraftList";

const ManageCollections = () => {
  const history = useHistory()
  const {
    isLoadingCollections,
    rejectedCollections,
    verifiedCollections,
    unverifiedCollections,
    draftCollections,
    updatedCollections,
    refreshCollections,
  } = useApi()
  const { getUserJWT, currentUserMetadata, setIsLoadingOverlayDisplay } = useAuth()
  const onAddNewCollection = useCallback(() => {
    history.push(`${Routes.MANAGE_DRAFT}/`)
  }, [history])
  const onRefresh = useCallback(async () => {
    setIsLoadingOverlayDisplay(true)
    await refreshCollections(
      (await getUserJWT()) as string,
      currentUserMetadata as UserMetadata 
    )
    setIsLoadingOverlayDisplay(false)
  }, [refreshCollections, getUserJWT])
  useEffect(() => {
    onRefresh()
  }, [])

  return (
    <div className="flex flex-col w-11/12 mx-auto mb-12">
      <div className="mt-8 flex flex-row mb-4 justify-between items-center sm:flex-row">
        <h1 className="font-semibold text-3xl text-left">
          COLLECTIONS MANAGEMENT
        </h1>

        <div className="w-full sm:w-auto flex items-center space-x-4">
          <Button
            type="button"
            className="mb-0 sm:mb-2 w-auto btn bg-kyzzen-primary border border-gray-70 flex items-center text-gray-70"
            onClick={onAddNewCollection}
            disabled={isLoadingCollections}
          >
            ADD NEW COLLECTION
            <PlusCircleIcon className="h-5 inline ml-2"/>
          </Button>
          <Button
            type="button"
            className="mb-0 sm:mb-2 w-auto btn  bg-kyzzen-secondary text-gray-100 flex items-center"
            onClick={onRefresh}
            disabled={isLoadingCollections}
          >
            REFRESH
            <Refresh className="h-5 inline"/>
          </Button>
        </div>
      </div>
      <div className="mb-4">
        <h2 className="text-lg sm:text-2xl my-4">REJECTED</h2>
        <NotificationList
          collections={rejectedCollections}
          stage={CollectionStage.rejected}
        />
      </div>
      {/* <div className="mb-4">
        <h2 className="text-lg sm:text-2xl my-4">PENDING UPDATES</h2>
        <NotificationList
          collections={updatedCollections}
          stage={CollectionStage.live}
        />
      </div> */}
      <div className="mb-4">
        <h2 className="text-lg sm:text-2xl my-4">DRAFT</h2>
        <DraftList
          collections={draftCollections}
          stage={CollectionStage.draft}
        />
      </div>
      <div className="mb-4">
        <h2 className="text-lg sm:text-2xl my-4">UNVERIFIED</h2>
        <NotificationList
          collections={unverifiedCollections}
          stage={CollectionStage.live}
        />
      </div>
      <div className="mb-4">
        <h2 className="text-lg sm:text-2xl my-4">VERIFIED</h2>
        <NotificationList
          collections={verifiedCollections}
          stage={CollectionStage.live}
        />
      </div>
    </div>
  )
};

export default memo(ManageCollections);
